export const COVEO_TOKEN_LOCAL_STORAGE_KEY = 'coveo-token';
export const COVEO_STANDALONE_SEARCH_BOX_DATA =
  'coveo_standalone_search_box_data';
